/**
 * Время реплики от начала ВСЕГО видео, а не от начала папки.
 *
 * Лекция режется на папки по три-пять минут, и в редакторе у реплики показано время от начала её
 * папки: «0:01:48». Чтобы назвать место коллеге или сверить с исходным видео, оператору нужно
 * знать, где это в целой лекции, — а смещение папки нигде не показано и считается в уме.
 *
 * Смещение приходит с сервера в поле `prev_mp3_length_aggr` (сумма длительностей предыдущих папок,
 * миллисекунды, строкой). Проверено живым запросом, что времена самих реплик локальные для папки:
 * папка 2 — смещение 297192, первая реплика 99; папка 5 — 1191096 и 59.
 */

/** Смещение папки от начала видео, мс. `null` — посчитать не из чего. */
export const getFolderOffsetMs = (args: {
    subtitlesDataAll?: Record<string, Array<{ prev_mp3_length_aggr?: string }> | undefined> | null;
    originalLang?: string | null;
    lang?: string | null;
    /** Номер папки как в интерфейсе — с единицы. */
    folder?: number | null;
}): number | null => {
    const { subtitlesDataAll, originalLang, lang, folder } = args || {};
    if (!subtitlesDataAll || !folder || folder < 1) return null;

    // Смещение одинаково во всех языках — папка копируется целиком, — но исходный язык есть
    // всегда, а перевода может ещё не быть.
    const folders =
        (originalLang ? subtitlesDataAll[originalLang] : undefined) ??
        (lang ? subtitlesDataAll[lang] : undefined);
    if (!Array.isArray(folders)) return null;

    const raw = folders[folder - 1]?.prev_mp3_length_aggr;
    if (raw === null || raw === undefined) return null;

    // Именно Number.isFinite, а НЕ `parseInt(...) || 0`. Ноль здесь — правдоподобное враньё: он
    // выдаст время первой папки для любой другой, и ошибку заметят не сразу.
    const parsed = Number.parseInt(String(raw), 10);
    if (!Number.isFinite(parsed) || parsed < 0) return null;
    return parsed;
};

/** Локальное время реплики → время от начала видео. `null`, если смещение неизвестно. */
export const toGlobalMs = (localMs: number, offsetMs: number | null): number | null => {
    if (offsetMs === null || !Number.isFinite(localMs)) return null;
    return offsetMs + localMs;
};
